export default __webpack_public_path__ + "static/media/carousel-left-green-btn-icon.680bcd08.svg";